var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"report-agent-wrapper"},[_c('ReportTable',{attrs:{"data-props":_vm.dataProps}},[_c('AgentTableTotal',{attrs:{"slot":"tableTotal","data-props":_vm.dataProps},slot:"tableTotal"})],1),(!_vm.loading)?_c('ReportAgentSummary'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }